<template>
  <b-modal
    id="move-folder-modal"
    name="move-folder-modal"
    ref="movefoldermodal"
    title="Move folder"
    size="lg"
    :busy="loading"
    ok-title="Move"
    close-title="Cancel"
    hide-header-close
    :ok-disabled="!selectedFolder"
    @shown="shown"
    @ok="handleOk"
    @cancel="handleCancel">
    <folders-list :folders="folders" :currentFolder="folder"></folders-list>
    <span v-if="selectedFolder">This folder will be moved to <strong>{{ selectedFolder.name }}</strong></span>
    <div slot="modal-ok" v-if="loading">
      <icon name="spinner" pulse></icon> Moving
    </div>
  </b-modal>
</template>

<script>
  import FoldersList from '@/components/FoldersList'
  import utilsMixin from '@/mixins/utils'
  export default {
    components: { FoldersList },
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      },
      selectedFolder () {
        return this.$store.state.selectedFolder
      }
    },
    data () {
      return {
        folders: [],
        loading: false
      }
    },
    props: {
      folder: Object
    },
    mixins: [utilsMixin],
    methods: {
      clearModal () {
        this.loading = false
        this.$store.commit('setSelectedFolder', null)
      },
      getPrimaryFolders () {
        this.$http.get(
          `/api/folder/primary?atlassian_project_id=${this.currentProject.id}`,
        ).then(response => {
          this.folders = response.data.folders
        }, response => {
          console.log('error')
        })
      },
      handleOk (e) {
        e.preventDefault()
        // Hitting the Move button in the modal
        // This validateAll is needed for the case when nothing has been entered yet
        // Otherwise it was letting it validate
        // The empty then/catch avoids a console error
        this.$validator.validateAll().then(() => {
        }).catch(() => {
        })
        if (this.errors.any()) {
          return e.cancel()
        } else {
          this.loading = true
          this.submitData()
        }
      },
      handleCancel (e) {
        this.clearModal()
      },
      shown () {
        this.getPrimaryFolders()
      },
      setTheState () {
        // This potentially updates the name, so both the list and the detail need updating
        this.$store.commit('setNeedToRefreshItemsList', true)
        this.$store.commit('setNeedToRefreshRequirementsDetail', true)
      },
      submitData () {
        this.$ga.event('folder', 'move', this.folder.folder_id, 1)
        let folderToSubmit = this.folder
        folderToSubmit.parent_folder_id = this.selectedFolder.folder_id
        this.$http.put(
          '/api/folder/' + this.folder.folder_id,
          folderToSubmit
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: 'Folder moved successfully',
            type: 'success',
            close: 'auto'
          })
          this.clearModal()
          this.setTheState()
          this.$refs.movefoldermodal.hide()
        }, error => {
          let errorString = this.createErrorStringFromResponse(error.response.data)
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem moving your folder: ${errorString}`,
            type: 'error',
            close: 'auto'
          })
          this.loading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MoveFolderModal.vue?ef7c29f4